import { get, post } from '@/api/core'

export namespace staff {
  /** 更新用户名 */
  export function updateUsername(name: string) {
    return post('/staff/name_update', {}, { name })
  }

  /** 更新密码 */
  export function updatePassword(p: { oldPassword: string; newPassword: string }) {
    return post('/staff/password_update', {}, p)
  }

  /** 移除成员 */
  export function remove(staffId: number) {
    return post('/staff/remove', {}, { staffId })
  }

  /** 邀请成员 */
  export function invite(email: string) {
    return post('/staff/invite', {}, { email })
  }

  /** 成员列表 */
  export function memberList(p: { pageNo: number; pageSize: number; keyword?: string }) {
    return get<{
      hasNext: boolean
      pageNo: number
      pageSize: number
      totalCount: number
      objects: MemberModels.MemberItem[]
      seatInfo: {
        baseSeatCount: number
        boundCount: number
      }
    }>('/staff/list', p)
  }

  /** 处理员工申请 */
  export function processStaffRequest(p: { staffId: number; status: 'deny' | 'approve' }) {
    return post('/staff/apply_process', {}, p)
  }

  /** 员工通知的开关设置 */
  export function updateNotification(isReceive: boolean) {
    return post('/staff/receive_notification/update', {}, { isReceive })
  }
}
